var map = {
	"./0.png": 767,
	"./1.png": 650,
	"./10.png": 244,
	"./2.png": 591,
	"./3.png": 189,
	"./4.png": 566,
	"./5.png": 874,
	"./6.png": 411,
	"./7.png": 494,
	"./8.png": 917,
	"./9.png": 894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;